// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 245 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"108":"f20876933257b5cf4f94","245":"c78f523d72327483ac18","452":"e0239ebc16ecec20e6f8"}[chunkId] + ".js";
};